
export const VACATION_STATUS = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED"
}

export function getVacationStatuses() {
    return Object.values(VACATION_STATUS);
}